export const NO_AUDIO_DEVICES = 'noAudioDevices';
export const NO_CONNECTION = 'noConnection';
export const NO_ACCOUNT = 'noAccount';
